import { all } from 'redux-saga/effects'

import gigRequestArtistSagas from './GigRequestArtist/GigRequestArtistSagas'
import gigRequestEventplannerSagas from './gig-request-eventplanner/sagas'
import authSagas from './Auth/AuthSagas'

export default function* rootSagas() {
  yield all([gigRequestArtistSagas(), gigRequestEventplannerSagas(), authSagas()])
}
